import base from "./base.service"
const ConnectToStripe = () => base.get('/payments/connectWithStripe');
const createCheckoutSession = (payload) => base.post('/payments/createCheckoutSession',payload);
const paymentCheckout=(payload)=>base.post('payments/emergencyPaymentCheckout',payload)
const ClientPaymentCheckout=(payload)=>base.post ('/payments/clientPaymentCheckout',payload)
const sponserPaymentCheckout =payload=>base.post(`/payments/sponsorRequestPaymentCheckout`,payload)

export const paymnetService ={
    ConnectToStripe,
    createCheckoutSession,
    paymentCheckout,
    ClientPaymentCheckout,
    sponserPaymentCheckout
}
